<script>
    export let fill = "#fff";
    export let size = 20;
</script>


<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   version="1.1"
   x="0px"
   y="0px"
   viewBox="0 0 47.050941 87.00473"
   enable-background="new 0 0 100 100"
   xml:space="preserve"
   id="svg10"
   width={size}
   height="auto"
   fill={fill}>
  <path
     d="m 30.629309,66.915529 -6.757,-11.251 -4.756,13.3 -9.412,14.333 v 0 c -1.532,2.605 -3.324,4.251 -5.859,3.542 -2.535,-0.704 -4.29100005,-3.514 -3.12200005,-6.024 l 9.61400005,-15.938 4.19,-15.281 c 0.248,-1.404 -0.628,-3.665 -0.628,-3.665 -0.825,-3.146 -0.264,-5.015 -0.264,-5.015 l 2.489,-14.3 -6.188,5.373 -2.542,10.853 c -0.398,2.271 -1.628,3.963 -3.734,3.981 -2.108,0.018 -3.83600005,-1.851 -3.64600005,-3.822 v 0 l 3.27200005,-13.481 c 0.404,-2.639 1.901,-3.517 1.901,-3.517 l 13.543,-9.708 c 7.875,-3.026 13.004,2.434 13.004,2.434 l 6.579,13.148 7.43,5.672 c 1.594,1.718 1.799,4.125 0.236,5.587 -1.343,1.256 -3.914,0.406 -5.195,-0.917 l -6.454,-4.916 c -1.272,-0.765 -4.2,-6.852 -4.2,-6.852 l -1.978,12.878 c -0.331,1.586 0.477,2.602 0.477,2.602 l 10.147,16.26 2.829,18.652 v 0 c 0.665,3.059 -0.693,5.254 -3.05,5.863 -2.483,0.643 -4.805,-0.849 -5.415,-3.295 z"
     id="path2" /><ellipse
     transform="rotate(-10.376083)"
     cx="27.789837"
     cy="12.570872"
     rx="7.1006622"
     ry="7.36865"
     id="ellipse4"
     style="stroke-width:0.999952" /></svg>
